/* rotating logo cloud module */
class RotatingLogoCloud {
  constructor(container) {
    this.container = container;
    this.logos = container.querySelector('.logoCloud__logos');
    this.originalItems = Array.from(this.logos.children);
    this.isPlaying = false;
    this.currentOffset = 0;
    this.animationId = null;

    this.init();
  }

  init() {
    if (this.originalItems.length === 0) return;

    this.createSeamlessLoop();

    const styles = getComputedStyle(this.logos);
    this.gap = parseFloat(styles.columnGap) || 0;

    this.calculateDimensions();

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReducedMotion) {
      this.start();
    }

    this.handleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.handleResize);
  }

  createSeamlessLoop() {
    this.originalItems.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('data-marquee-clone', 'true');
      this.logos.appendChild(clone);
    });
  }

  calculateDimensions() {
    this.logos.style.transform = '';

    let originalWidth = 0;
    this.originalItems.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      originalWidth += rect.width;
      if (index < this.originalItems.length - 1) {
        originalWidth += this.gap;
      }
    });

    this.originalContentWidth = originalWidth;

    this.resetDistance = this.originalContentWidth + this.gap;
  }

  start() {
    if (this.isPlaying) return;

    this.isPlaying = true;

    const duration = getComputedStyle(this.logos).getPropertyValue('--time-duration');
    const durationMs = parseFloat(duration) * 1000 || 30000;

    this.speed = this.resetDistance / durationMs;

    this.animate();
  }

  animate() {
    if (!this.isPlaying) return;

    const now = performance.now();
    if (!this.lastTime) this.lastTime = now;

    const deltaTime = now - this.lastTime;
    this.lastTime = now;

    this.currentOffset += this.speed * deltaTime * 2;
    if (this.currentOffset >= this.resetDistance) {
      this.currentOffset = this.currentOffset % this.resetDistance;
    }

    this.logos.style.transform = `translateX(-${this.currentOffset}px)`;

    this.animationId = requestAnimationFrame(() => this.animate());
  }

  handleResize() {
    this.calculateDimensions();

    this.currentOffset = 0;
    this.lastTime = null;
  }
}

/**
 * Initializes all logo cloud marquees on the page.
 */
function initMarquees() {
  const marqueeContainers = document.querySelectorAll('.logoCloud--marquee');

  marqueeContainers.forEach((container) => {
    if (!container.dataset.marqueeInitialized) {
      new RotatingLogoCloud(container);
      container.dataset.marqueeInitialized = 'true';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMarquees);
} else {
  initMarquees();
}

export {RotatingLogoCloud, initMarquees};
